module.exports = __webpack_public_path__ + "static/media/shield.d887a2cb.svg";